import { DOCUMENT } from '@angular/common';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { AppConfigurationService } from '../../../app-configuration.service';
import { counter } from '../../../shared/constant/counter.constatnt';
import { Gender } from '../../../shared/enum/gender.enum';
import { Relationship } from '../../../shared/enum/relationship.enum';
import { YesNo } from '../../../shared/enum/yesNo.enum';
import { AdditionalInsurers } from '../../../shared/models/contract/additional-insurer.model';
import { PersonType } from '../../../shared/models/contract/person-type.model';
import { LookUpMasterModel } from '../../../shared/models/lookup-master/lookup-master.model';
import { CommonService } from '../../../shared/service/common.service';
import { StartUpConfigUiService } from '../../../shared/service/ui/start-up-config-ui.service';
import { BaseCJQuestion } from '../../extended-class/base-cj-question';
import { AdditionalInsurersValidationService } from '../../service/additional-insurer-validation.service';
import { Utils } from 'src/app/shared/Utils/Utils';
declare function maskingDob(): any;

@Component({
  selector: 'app-insured-detail',
  templateUrl: './insured-detail.component.html'
})
export class InsuredDetailComponent extends BaseCJQuestion implements OnInit {
  public baseImageUrl: string;

  constructor(
    private commonService: CommonService,
    private insurersValidationService: AdditionalInsurersValidationService,
    @Inject(DOCUMENT) private document: Document,
    private appConfigService: AppConfigurationService,
    serviceInjector: Injector,
    private startUpConfigUiService: StartUpConfigUiService
  ) {
    super(serviceInjector);
  }

  public ngOnInit(): void {
    if (this.customerJourneyService.contractType) {
      this.contractType = this.customerJourneyService.contractType;
    }

    if (this.appConfigService.getURLConfig?.baseImageUrl) {
      this.baseImageUrl = this.appConfigService.getURLConfig.baseImageUrl;
    }

    if (this.contractType?.policyHolder?.personType.length === 0) {
      this.contractType.policyHolder.personType.push(new PersonType());
    }

    this.document.getElementById('count-plus')?.addEventListener('click', function () {
      maskingDob();
    });

    document.getElementById('count-minus')?.addEventListener('click', function () {
      maskingDob();
    });
    this.counterService.processCounterByCounterName(counter.InsuredPage).subscribe();
    const sectionNumber = 1;
    const questionText = this.getAllSectionQuestionText(sectionNumber, true);
    this.startUpConfigUiService.sessionInfo$.subscribe({
      next: () => {
        this.startUpConfigUiService.loadConsentScript$.subscribe((isScriptLoaded) => {
          if (isScriptLoaded) {
            this.gtmDatalayerUiService.addVirtualPage('customerjourney', 'Q1', sectionNumber, questionText, 'default', 'V1').toPromise();
          }
        });
      }
    });
  }

  public moveNext(): void {
    if (this.validationUiService.isValidInsuredPage(this.contractType)) {
      this.addGTMAnswerString();
      this.customerJourneyService.updateContractType(this.contractType);
      this.router.navigate([Utils.getBaseRoute()], {
        relativeTo: this.activatedRoute,
        queryParamsHandling: 'merge',
        fragment: 'Q2'
      });
    }
  }

  public addInsurer(): void {
    if (this.contractType.policyHolder.personType.length < 9) {
      const insurer = new PersonType();
      this.contractType.policyHolder.personType.push(insurer);
      this.insurersValidationService.addInsurer();
    }
  }

  public removeInsurer(): void {
    if (this.contractType.policyHolder.personType.length > 1) {
      this.contractType.policyHolder.personType.pop();
      this.insurersValidationService.removeInsurer();
    }
  }

  public getFilteredQuestion(questionkey: string): LookUpMasterModel {
    return this.getQuestionModelByKey(questionkey);
  }

  public selectGender(value: number): void {
    this.contractType.policyHolder.personType[0].gender = value === 0 ? Gender.Hombre : Gender.Mujer;
  }

  public isGenderSelected(value: Gender): boolean {
    return this.contractType.policyHolder.personType[0].gender === value;
  }

  public submitPrimaryDOB(dob: string): void {
    const formatDate = this.commonService.formatDob(dob);
    if (formatDate !== '') {
      this.contractType.policyHolder.personType[0].birthDate = this.commonService.formatDate(formatDate);
      this.contractType.policyHolder.personType[0].number = 1;
      this.contractType.policyHolder.personType[0].birthAgeInYears = this.commonService.getAgeUsingDateOfBirth(dob);
      this.contractType.policyHolder.personType[0].insured = YesNo.Yes;
    }
  }

  public submitAdditionalDOB(insurer: AdditionalInsurers): void {
    const formatDate = this.commonService.formatDob(insurer.date);
    if (formatDate !== '') {
      this.contractType.policyHolder.personType[insurer.index + 1].birthDate = this.commonService.formatDate(formatDate);
      this.contractType.policyHolder.personType[insurer.index + 1].number = insurer.index + 2;
      this.contractType.policyHolder.personType[insurer.index + 1].birthAgeInYears = this.commonService.getAgeUsingDateOfBirth(insurer.date);
      this.contractType.policyHolder.personType[insurer.index + 1].relationshipWithPolicyHolder = Relationship.Other;
      this.contractType.policyHolder.personType[insurer.index + 1].gender = Gender.Hombre;
      this.contractType.policyHolder.personType[insurer.index + 1].insured = YesNo.Yes;
    }
  }

  public submitPolicyStartDate(policyStartDate: string): void {
    this.contractType.policyStartRealDate = this.commonService.formatDate(policyStartDate) ?? null;
  }

  public selectOtherHealthInsurance(value: number): void {
    this.contractType.otherHealthInsurance = value === 1;
  }

  public isOtherHealthInsurance(value: number): boolean {
    if (value === 1 && true === this.contractType.otherHealthInsurance) {
      return true;
    }
    if (value === 0 && false === this.contractType.otherHealthInsurance) {
      return true;
    }
    return false;
  }

  private addGTMAnswerString(): void {
    const additionalInsured =
      this.contractType.policyHolder.personType.length > 0
        ? ' - ' +
          this.contractType.policyHolder.personType
            .filter((p) => p.number !== 1)
            ?.map((m) => m.birthAgeInYears)
            ?.join(' - ')
        : '';

    const gtmAnswerStr = `${this.contractType.otherHealthInsurance} - ${this.contractType.policyStartRealDate} - ${
      this.contractType.policyHolder.personType[0].birthAgeInYears
    } - ${this.contractType.policyHolder.personType[0].gender.toString()} ${additionalInsured}`;
    this.addGTMAnswer('Q1', gtmAnswerStr);
  }
}
